
import PaneTitle from '@/components/panes/PaneTitle.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ParadigmDGNB',
  props: {
    index: {
      type: Number,
      required: true,
    },
  },
  components: { PaneTitle },
})
